/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
const buildPages = (result, survey) => {
  // include only 3 qtypes
  if (
    result.question.__typename === 'SingleChoiceQuestionQM' ||
    result.question.__typename === 'MultipleChoiceQuestionQM' ||
    result.question.__typename === 'MultipleChoiceImageQuestionQM'
  ) {
    const pageId = result?.question?.position?.pageId || 1;
    if (!survey.pages[pageId]) {
      survey.pages[pageId] = [];
    }
    survey.pages[pageId].push(result);
    result.answeredLookup = {};
    const other = result.question.answerOther;
    if (other) {
      result.question.quiz.answers.push({ answer: other, points: 0 });
    }
    result.answers.forEach(answer => {
      const answerId = answer?.choiceAnswer?.id || answer?.answerOther?.id;
      if (answerId) {
        result.answeredLookup[answerId] = true;
      }
      if (answer.__typename === 'OtherResponse') {
        result.question.quiz.answerOther = { textAnswer: answer.textAnswer };
      }
    });
  }
};

const _populateQuizAnswers = result => {
  result.question.quiz.answers &&
    result.question.quiz.answers.forEach(answer => {
      answer.responded = !!result.answeredLookup[answer.answer.id];
      answer.id = answer.answer.id;
      answer.label = answer.answer.label;
      if (result.question.__typename === 'MultipleChoiceImageQuestionQM') {
        if (answer.answer.__typename !== 'ImageAnswer') {
          answer.answer.image = { url: '', altText: '' };
        }
        if (answer.answer.image && !answer.answer.image.altText) {
          answer.answer.image.altText = '';
        }
        result.question.answersImage.push(answer.answer);
      }
    });
};

const _populateQuestionHeader = result => {
  const variation = result?.question?.heading.assignments?.find(({ id }) => id === result?.variation?.id);
  if (variation?.heading.text) {
    result.question.heading.default.text = variation?.heading.text;
  }
  if (result?.question?.heading?.assignments) {
    delete result.question.heading.assignments;
  }
};

const buildQuestions = result => {
  // populate question attribs such as responded and headers
  if (result?.question?.quiz?.answers) {
    if (!result.question.answersImage) {
      result.question.answersImage = [];
    }

    if (result.question.quiz.answers[0]?.answer?.id === result.question.answerNA?.id) {
      const nota = result.question.quiz.answers.splice(0, 1);
      result.question.quiz.answers.push(nota[0]);
    }

    result.question.answerNoneOfTheAbove = result.question.answerNA || null;
    _populateQuizAnswers(result);
    result.question.quizResults = result.question.quiz;

    _populateQuestionHeader(result);

    if (result.question.__typename !== 'MultipleChoiceImageQuestionQM') {
      // keep this for multi choice question
      result.question.answers = result.question.quiz.answers;
    }
  }
};

const formatSurvey = (results, enableNumbering = false, showQuizAnswers = false) => {
  const survey = { enableNumbering, showQuizAnswers, pages: {} };
  if (results) {
    results.forEach(result => {
      // use only quiz type questions
      if (result?.question?.quiz) {
        buildPages(result, survey);
        buildQuestions(result);
      }
    });
  }
  Object.keys(survey.pages).forEach(pageId => {
    survey.pages[pageId].sort(function comparator(a, b) {
      return a.question?.position?.inPage - b.question?.position?.inPage;
    });
    survey[pageId] = survey.pages[pageId];
  });
  return survey;
};

export default formatSurvey;
